import { AppBar, Avatar, Box, Menu, Toolbar } from "@mui/material";
import styled from "@emotion/styled";

export const APP_HEADER_HEIGHT = 80;

export const AppBarHeader = styled(AppBar)({
  background: "#FFF",
});

export const AppBarContainer = styled(Toolbar)({
  height: APP_HEADER_HEIGHT,
});

export const HeaderUser = styled(Box)({
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  gap: 16,
  paddingLeft: 24,
});

export const AvatarUser = styled(Avatar)({
  width: 56,
  height: 56,
});

export const UserMenuList = styled(Menu)({
  marginTop: 12,
});

export const LogoContainer = styled(Box)({
  height: APP_HEADER_HEIGHT,
  width: "auto",
  padding: "12px 0",
});
